import { ReactNode } from 'react';

import { Box, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { isNotFoundError } from '@spotify/confidence-graphql';

import { NotFoundContent } from '../Page/Wrapper/presets/ResourceGuard/NotFoundContent';
import Body from './Body';
import CloseButton from './CloseButton';
import Header from './Header';

export type ResourceGuardProps = {
  error?: Error | null;
  loading?: boolean;
  loadingFallback?: ReactNode;
  children: ReactNode;
};

const FallbackShell = ({
  children,
  autoHeight,
}: {
  children: ReactNode;
  autoHeight?: boolean;
}) => (
  <>
    <Header>
      <CloseButton />
    </Header>
    <Body autoHeight={autoHeight}>{children}</Body>
  </>
);

export const ResourceGuard = ({
  error,
  loading,
  loadingFallback,
  children,
}: ResourceGuardProps) => {
  if (error) {
    if (isNotFoundError(error)) {
      return (
        <FallbackShell autoHeight>
          <NotFoundContent variant="resource" fillViewport={false} />
        </FallbackShell>
      );
    }

    return (
      <FallbackShell>
        <Alert severity="error">{error.message}</Alert>
      </FallbackShell>
    );
  }

  if (loading) {
    return (
      <FallbackShell>
        {loadingFallback ?? (
          <Box display="flex" justifyContent="center" p={4}>
            <CircularProgress />
          </Box>
        )}
      </FallbackShell>
    );
  }

  return <>{children}</>;
};

ResourceGuard.displayName = 'DialogComposite.ResourceGuard';

export default ResourceGuard;
